export default __webpack_public_path__ + "dist/media/Document.3dc2b0ec.svg";